import { initCustomChatbot } from '../../../chatbot';

const PageFrontPageT4A = (function ($) {

    function initEvents() {
        setTimeout(() => {
            initCustomChatbot();
        }, 1000);
    }



    function initialize() {
        initEvents();
    }

    return {
        init: initialize
    }
})(jQuery);

export { PageFrontPageT4A };